export default function () {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            progressText: '@',
            extraMessageText: '@',
            cancel: '&onCancel',
            cancelText: '@'
        },
        /* eslint-disable no-param-reassign */
        link: (scope, elem, attrs) => {

            scope.hasCancelFunction = () => {
                return angular.isDefined(attrs.onCancel);
            };
        },
        template: `<div class="progress-container">
    <div class="alert alert-info eight-padding text-center" role="alert" ng-if="extraMessageText.length > 0"
        style="margin-left: 18px; margin-right: 18px; }">
        <p class="full-paragraph">
            {{extraMessageText}}
        </p>
    </div>

    <div class="progress-animation text-center">
        <lottie-player src="https://assets8.lottiefiles.com/packages/lf20_9teijcbs/loading_animation.json"
            background="transparent" speed="1" loop autoplay>
        </lottie-player>
    </div>
    <div class="progress-text text-center" <span>{{progressText}}</span>
    </div>

    <div class="progress-cancel-action text-center" ng-if="hasCancelFunction()">
        <a class="cancel-action-button" href="javascript:void(0);" ng-click="cancel()">{{cancelText}}</a>
    </div>

</div>`
    };
};